import { AxiosResponse } from 'axios'
import { queryOptions } from '@tanstack/react-query'
import { createUrl } from './helpers'
import axiosAuth from './config'
import { NHouseRules } from '../interfaces/services/house-rules.interfaces'
import { sortStringsAlphabetically } from '../helpers/sorting'

export const getHouseRulesPerSociety = (
  societyId: string
): Promise<AxiosResponse<NHouseRules.NGetPerSocieties.IResponse>> => {
  const body: NHouseRules.NGetPerSocieties.IRequestBody = {
    societyIds: [societyId],
  }
  return axiosAuth.post<NHouseRules.NGetPerSocieties.IResponse>(
    createUrl(`/house-rules/get-per-societies`),
    body
  )
}

export const getHouseRule = (
  id: string
): Promise<AxiosResponse<NHouseRules.NGetById.IResponse>> => {
  return axiosAuth.get<NHouseRules.NGetById.IResponse>(
    createUrl(`/house-rules/rule/${id}`)
  )
}

export const createHouseRule = (
  body: NHouseRules.NCreate.IRequestBody
): Promise<AxiosResponse<NHouseRules.NCreate.IResponse>> => {
  return axiosAuth.post<NHouseRules.NCreate.IResponse>(
    createUrl(`/house-rules/rule`),
    body
  )
}

export const updateHouseRule = (variables: {
  id: string
  body: NHouseRules.NPatch.IRequestBody
}): Promise<AxiosResponse<NHouseRules.NPatch.IResponse>> => {
  return axiosAuth.patch<NHouseRules.NPatch.IResponse>(
    createUrl(`/house-rules/rule/${variables.id}`),
    variables.body
  )
}

export const deleteHouseRule = (
  id: string
): Promise<AxiosResponse<NHouseRules.NDel.IResponse>> => {
  return axiosAuth.delete<NHouseRules.NDel.IResponse>(
    createUrl(`/house-rules/rule/${id}`)
  )
}

export const houseRuleQueries = {
  getHouseRulesPerSociety: (societyId?: string) =>
    queryOptions({
      queryKey: [{ scope: 'houseRule', entity: 'society', societyId }],
      enabled: !!societyId,
      queryFn: async ({ queryKey }) => {
        const houseRules = (
          await getHouseRulesPerSociety(queryKey[0].societyId!)
        ).data.data
        houseRules?.sort((a, b) =>
          sortStringsAlphabetically(a.section, b.section)
        )
        return houseRules
      },
    }),
}
